export default "__VITE_PUBLIC_ASSET__343d4c85__"